import script from "./SelectAccountPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectAccountPage.vue?vue&type=script&setup=true&lang=ts"

import "./SelectAccountPage.vue?vue&type=style&index=0&id=5ee0e4af&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ee0e4af"]])

export default __exports__